import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Alert, CircularProgress, IconButton } from '@mui/material';
import { deleteUploads } from '../../services/stacks';
import './style.scss';

const ExhibitAttachmentPreview = ({ attachmentUrl, thumbnailUrl, setThumbnailBtn, setThumbnailUrl }) => {
    const [removingThumbnail, setRemoveThumbnail] = useState(false);

    async function deleteExhibitThumbnail() {
        setRemoveThumbnail(true);
        const { th_state, th_name } = thumbnailUrl;
        if (th_state) {
            await deleteUploads(th_name).then(({ success }) => {
                if (success) {
                    setThumbnailUrl({ th_url: '', th_file: null, th_name: '', th_state: false, type: '' });
                    setThumbnailBtn(false);
                }
            })
        }
        setRemoveThumbnail(false);
    }

    return (
        <div className="" style={{ position: 'relative', width: '100%' }}>

            {thumbnailUrl.th_state && (
                <div className='remove-exhibit-thumbnail'>
                    {removingThumbnail
                        ? <CircularProgress color="inherit" />
                        : <IconButton disabled={removingThumbnail} onClick={deleteExhibitThumbnail}>
                            <HighlightOffIcon fontSize='large' sx={{ color: 'white' }} />
                        </IconButton>
                    }
                </div>

            )}

            {thumbnailUrl.th_state && (
                <img src={thumbnailUrl.th_url} alt="preview" loading="quick" width='100%' gaiastoragename={thumbnailUrl.th_name} />
            )}

            <div className={`preview-exhibit ${thumbnailUrl.th_state ? 'preview-exhibit-attached' : ''}`} >
                <h1 className='preview-title'>{attachmentUrl.at_file}</h1>
                {attachmentUrl.at_state && !thumbnailUrl.th_state ? (
                    <Alert severity="info">Attachment type requires a thumbnail too</Alert>
                ) : null}
            </div>

        </div>
    );
};

export default ExhibitAttachmentPreview;